import React, { useState } from "react";
import { RotateCcw, X } from "lucide-react";

const ChatBotHeader = ({ imageurl, title, showExtraContent, toggleExtraContent, onRefresh }) => {

  return (
    <header className="krunk-flex krunk-justify-between krunk-items-center krunk-gap-0 krunk-rounded-t-xl krunk-bg-headercolor krunk-text-headertextcolor krunk-px-4 krunk-py-3">
      <div className="krunk-flex krunk-items-center krunk-gap-2 krunk-w-full">
        <img
          src={imageurl}
          alt=""
          style={{ width: "40px", height: "40px" }}
        />
        <div className="krunk-w-full">
          <div className="krunk-flex krunk-items-center krunk-gap-3 krunk-justify-between">
            <h1 className="krunk-text-lg krunk-font-semibold krunk-leading-7">
              {title}
            </h1>
            
            {/* Action Buttons Container */}
            <div className="krunk-flex krunk-items-center krunk-gap-2">
              {/* Refresh Button */}
              <button
                onClick={onRefresh}
                className="krunk-text-headertextcolor hover:krunk-text-blue-400 krunk-transition-colors krunk-duration-200"
                title="Refresh Chat"
              >
                <RotateCcw className="krunk-w-5 krunk-h-5" />
              </button>
              
              {/* Cross Button */}
              <button
                onClick={toggleExtraContent}
                className="krunk-text-headertextcolor hover:krunk-text-red-500 krunk-transition-colors krunk-duration-200"
                title="Close Chat"
              >
                <X className="krunk-w-5 krunk-h-5" />
              </button>
            </div>
          </div>
          <div className="krunk-flex krunk-items-center krunk-justify-between krunk-w-full">
            <div className="krunk-flex krunk-items-center krunk-gap-1"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ChatBotHeader;